import { MenuItem, Select } from "@mui/material";
import React, { useRef } from "react";
import { WorkflowNode } from "../../types/workflow";
import WorkflowAccordion from "../Common/WorkflowAccordion";
import AddIntegration from "./AddIntegration";
import { onNewAccountClick } from "./AddIntegration";

export interface TokenOption {
    id: string;
    type: 'service' | 'bot';
    serviceUniqueId: string;
    serviceReadableInfo: string;
    label: string;
}

interface TokenSelectionProps {
    nodeConfigs: Record<string, any>;
    nodeId: string;
    expandedSection: string;
    chosenAction: string;
    currentToken: TokenOption | null;
    tokenOptions: TokenOption[];
    setExpandedSection: (section: string) => void;
    handleTokenChange: (token: TokenOption | null) => void;
    workflowType: string;
    customFetch: any;
    workflowId: string;
    workflowNode: WorkflowNode;
}

const TokenSelection: React.FC<TokenSelectionProps> = ({
    nodeConfigs,
    nodeId,
    expandedSection,
    chosenAction,
    currentToken,
    tokenOptions,
    setExpandedSection,
    handleTokenChange,
    workflowType,
    customFetch,
    workflowId,
    workflowNode,
}) => {
    const nodeConfig = nodeConfigs[nodeId];
    const hasToken = !!nodeConfig?.service_auth_token_id;
    const hasAvailableTokens = tokenOptions.length > 0;
    const activeToken = currentToken?.id;
    const selectRef = useRef<HTMLDivElement>(null); // Reference to the Select component

    return (
        <WorkflowAccordion
            title="Connect your account"
            showNumber={!hasToken ? "2" : ""}
            showTick={!!hasToken}
            expanded={expandedSection === 'Connect your account'}
            isDisabled={!chosenAction}
            setExpandedSection={chosenAction ? () => setExpandedSection('Connect your account') : () => {}}
        >
            <div className="p-4 space-y-4">
                {/* Current Token Section */}
                {/* <div className="border rounded p-3">
                    <div className="text-sm font-medium mb-2">Current Account</div>
                    {currentToken ? (
                        <div className="flex items-center justify-between">
                            <div className="text-sm">{currentToken.label}</div>
                            <div className="text-xs text-gray-500">
                                {currentToken.serviceUniqueId}
                            </div>
                        </div>
                    ) : (
                        <div className="text-sm text-gray-500">No account connected</div>
                    )}
                </div> */}

                {/* Token Selection Section */}
                <div className="border rounded p-3">
                    <div className="text-sm font-medium mb-2">
                        {hasAvailableTokens ? "Select Account" : "Connect Account"}
                    </div>
                    {hasAvailableTokens ? (
                        <Select
                            ref={selectRef}
                            value={activeToken || ''}
                            onChange={(e) => {
                                if (e.target.value === 'new') {
                                    setExpandedSection('');
                                    return;
                                }
                                const token = tokenOptions.find(t => t.id === e.target.value);
                                handleTokenChange(token || null);
                            }}
                            displayEmpty
                            fullWidth
                            size="small"
                            MenuProps={{
                                PaperProps: {
                                  sx: {
                                    width: selectRef.current ? selectRef.current.offsetWidth : "auto",
                                  },
                                },
                                anchorOrigin: {
                                  vertical: "bottom",
                                  horizontal: "left",
                                },
                                transformOrigin: {
                                  vertical: "top",
                                  horizontal: "left",
                                },
                            }}
                        >
                            <MenuItem value="">
                                <em>Choose an account</em>
                            </MenuItem>
                            {tokenOptions.map((token) => (
                                <MenuItem key={`${token.type}-${token.id}`} value={token.id}>
                                    {token.label}
                                </MenuItem>
                            ))}
                            <MenuItem value="new" onClick={() => onNewAccountClick(workflowType, customFetch, workflowId, workflowNode, chosenAction)}>
                                <div className="text-blue-600">+ Connect New Account</div>
                            </MenuItem>
                        </Select>
                    ) : (
                        <AddIntegration
                            workflowType={workflowType}
                            isIntegrationPresent={false}
                            customFetch={customFetch}
                            workflowId={workflowId}
                            workflowNode={workflowNode}
                            chosenAction={chosenAction}
                        />
                    )}
                </div>
            </div>
        </WorkflowAccordion>
    );
};

export default TokenSelection; 